import { Box, Typography, CircularProgress } from '@mui/material';
import type { OrderDto } from '@/types/dtos/orders/response/order.dto.ts';
import { useTranslations } from '@/i18n/use-translations';

const PricingDisplay = ({
  latestOrder,
  latestOrderBillingCountry,
  vatCountryDisplay,
  loading = false,
}: {
  latestOrder: OrderDto & { vatAmount: number };
  latestOrderBillingCountry: string | undefined;
  vatCountryDisplay: string;
  loading?: boolean;
}) => {
  const t = useTranslations();

  // Display VAT warning instead if we dont have a billing country
  const displayVatCalculation = !!latestOrderBillingCountry;

  return (
    <>
      <Box display="flex" justifyContent="space-between" sx={{ mt: 'auto' }}>
        <Typography variant="body2" sx={{ fontWeight: !displayVatCalculation ? 900 : undefined }}>
          {t('event.checkoutModal.subtotalExcludingVat')}
        </Typography>
        {loading ? (
          <CircularProgress size={16} />
        ) : (
          <Typography variant="body2" sx={{ fontWeight: !displayVatCalculation ? 900 : undefined }}>
            €{latestOrder.totalPrice.toFixed(2)}
          </Typography>
        )}
      </Box>
      {displayVatCalculation ? (
        <>
          <Box display="flex" justifyContent="space-between" borderBottom={1} borderColor="divider">
            <Typography variant="body2">
              {t('event.checkoutModal.vat', {
                vat: latestOrder.vat.toFixed(2) ?? t('common.N/A'),
                country: vatCountryDisplay ?? t('common.N/A'),
              })}
            </Typography>
            {loading ? (
              <CircularProgress size={16} />
            ) : (
              <Typography variant="body2">€{latestOrder.vatAmount.toFixed(2)}</Typography>
            )}
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" fontWeight={900}>
              {t('event.checkoutModal.totalIncludingVat')}
            </Typography>
            {loading ? (
              <CircularProgress size={16} />
            ) : (
              <Typography variant="body2" fontWeight={900}>
                €{latestOrder.totalPriceWithVat.toFixed(2)}
              </Typography>
            )}
          </Box>
        </>
      ) : (
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">{t('event.checkoutModal.noVatExplanation')}</Typography>
        </Box>
      )}
    </>
  );
};

export default PricingDisplay;
